import { render, staticRenderFns } from "./ListContrats.vue?vue&type=template&id=56cd0730&"
import script from "./ListContrats.vue?vue&type=script&lang=ts&"
export * from "./ListContrats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports